export default __webpack_public_path__ + "static/media/Arrow.498fa8b3.svg";